import { Controller } from "@hotwired/stimulus"
import { mount, unmount } from "svelte"
import { ProductCarouselEditor } from "../product_carousel_editor/product_carousel_editor.svelte.js"
import ProductDescriptions from "../product_carousel_editor/ProductDescriptions.svelte"

// A campaign's Product Carousel section: mounts the per-product description boxes
// (app/javascript/product_carousel_editor) under the tom-select product picker and keeps them in step with its chips.
export default class extends Controller {
  static targets = ["select", "descriptions"]
  static values = { products: Array, fieldPrefix: String }

  connect() {
    this.editor = new ProductCarouselEditor({ products: this.productsValue })
    this.component = mount(ProductDescriptions, {
      target: this.descriptionsTarget,
      props: { editor: this.editor, fieldPrefix: this.fieldPrefixValue }
    })
    this.sync = () => this.editor.sync(this.picks())
    this.selectTarget.addEventListener("change", this.sync)
  }

  disconnect() {
    this.selectTarget.removeEventListener("change", this.sync)
    if (this.component) unmount(this.component)
    this.component = null
  }

  // The picked products in chip order. A product picked from search carries its photo in tom-select's option data.
  picks() {
    const options = this.selectTarget.tomselect?.options || {}
    return Array.from(this.selectTarget.selectedOptions).map((option) => ({
      id: Number(option.value),
      name: option.text,
      image_url: options[option.value]?.image_url
    }))
  }
}
